import { htmlEscape as h } from "../utils.js";

export function insertTable() {
  const tableTemplate = document.getElementById(
    "document-list-datatables-table-tpl",
  );
  if (tableTemplate) {
    document
      .getElementById("documents")
      .replaceChildren(tableTemplate.content.cloneNode(true));
    if (!toggles.files.showNewDocument) {
      document.querySelector(".document-list-actions").remove();
    }
    if (!toggles.files.showDraftsFilterCategory) {
      document
        .querySelector(
          ".document-list-filters .nav-item[data-document-list-filter-param='drafts']",
        )
        .remove();
    }
  }
  document
    .getElementById("iCaseworkContent")
    .prepend(
      document.getElementById("document-menu-tpl").content.cloneNode(true)
    );
}

const dataTablesColumnsVersion = "v1";

export function localStorageStateKey(settings) {
  return "DataTables_" + dataTablesColumnsVersion + "_" + settings.sInstance;
}

/*
 * The positions of columns in this array are persisted in the browser
 * local storage by DataTables' state persistence feature. If new columns
 * are added to the list we must not reuse persisted state from the previous
 * version of the table columns. So, when adding or removing columns to the
 * array below, also increment the version number in `dataTablesColumnsVersion`
 * above.
 */
export function dataTableColumns(controller) {
  const documentIdToParam = controller.documentIdToParam;

  return [
    {
      data: null,
      render: DataTable.render.select(),
      // force select all checkbox in header to appear. May not be needed if
      // apparent bug in DataTables is fixed
      className: "dt-select",
      responsivePriority: 0,
    },
    {
      data: null,
      className: "dtr-control th-control",
      orderable: false,
      defaultContent: "",
    },
	{
	  data: null,
	  name: "attachmentChevron",
	  className: "th-attachment-control attachment-details-control",
	  orderable: false,
	  defaultContent: "",
	  visible: false,
	  responsivePriority: 9,
	  render: (data, type, row) => {
	    if (type !== "display") return "";

	    const isEmail = row.email || row.emailBody;
	    const hasAttachments =
	      (controller.attachmentsByTxn?.[row.transactionId]?.length || 0) > 0;

	    if (!isEmail || !hasAttachments) return "";

	    return `
	      <button type="button" class="btn btn-link p-0 attachment-toggle" aria-label="Show attachments">
	        <i class="fa fa-angle-right" aria-hidden="true"></i>
	      </button>
	    `;
	  },
	},
	{
      name: "category",
      data: "category",
      title: "Category",
      responsivePriority: 10,
      render: (data, type, row) => {
        if (type != "display") {
          return data;
        }
        return (
          (controller.config.useRefactoredHtmlDocumentViewEmailGrouping &&
          controller.activeFilter !== "deleted" &&
          row.emailAttachment && !controller.config?.useEnhancedEmailThreading
            ? '<div style="display:flex">' +
              '<div style="padding-right:0.75em">' +
              '<span aria-label="Attachment"><i class="fa fa-angle-right"></i></span>' +
              "</div>"
            : "") +
          (row.bundle
            ? data
            : `<div data-controller="category-dropdown" ` +
              `data-category-dropdown-category-name-value="${data}" ` +
              `data-category-dropdown-code-type-value="${controller.config.codeType}" ` +
              `data-category-dropdown-security-id-value="${controller.config.securityId}" ` +
              `data-category-dropdown-base-url-value="${controller.config.baseURL}" ` +
              `data-category-dropdown-document-id-value="${row["documentId"]}">` +
              `</div>`) +
          (controller.config.useRefactoredHtmlDocumentViewEmailGrouping &&
          row.emailAttachment
            ? "</div>"
            : "")
        );
      },
    },
    toggles.files.showSourceColumn && {
      name: "source",
      data: "source",
      title: "Source",
      responsivePriority: 11,
    },
    {
      name: "documentId",
      data: "documentId",
      title: "Id",
      visible: false,
      responsivePriority: 9,
      render: (value, options, rowData) => {
        return `<span data-document-id="${value}" data-is-bundle="${rowData.bundle}">${value}</span>`;
      },
    },
    {
      name: "documentType",
      data: "documentType",
      title: "Group",
      responsivePriority: 10,
      render: (data, type, row) => {
        let typeDescription = "";
        if (row.bundle) {
          typeDescription = "Bundle";
        } else if (row.link) {
          typeDescription = "Link";
          // Video files have image:true from the backend (documentType:"I"), so check
          // mediaType before the generic image check to get the correct label
        } else if (row.mediaType?.type === 'video') {
          typeDescription = "Video";
        } else if (row.image) {
          typeDescription = "Image";
        } else if (row.audio) {
          typeDescription = "Audio";
        } else if (row.spreadsheet) {
          typeDescription = "Spreadsheet";
        } else if (row.emailBody || row.email) {
          typeDescription = "Email";
        } else if (row.editableCorrespondenceItem) {
          typeDescription = "Draft";
        } else if (row.microsoftWordContentType) {
          typeDescription = "Word";
        } else if (row.pdfContentType) {
          typeDescription = "PDF";
        } else {
          typeDescription = "Document";
        }
        return `<span>${typeDescription}</span>`;
      },
    },
    {
      name: "iconClass",
      data: "iconClass",
      orderable: false,
      className: "th-doctype",
      title: '<span class="sr-only" title="Type">Type</span>',
      responsivePriority: 9,
      render: (value, options, rowData) => {
        return `<i class="fa ${rowData.iconClass} fa-lg" aria-hidden="true"></i>`;
      },
    },
    {
      name: "documentName",
      data: "documentName",
      title: "Name",
      responsivePriority: 9,
      render: (data, type, document) => {
        if (type != "display") {
          return data;
        }		
        const documentId = document.documentId;
        const editableUrl = document.editableUrl;

        // Video and audio files have actionUrls.open = null (no preview URL from backend).
        // Fall back to documentUrl (raw streaming URL without save=yes) so the name link
        // is enabled and opens the file in the browser's native media player.
        const isMedia = document.mediaType?.type === 'video' || document.mediaType?.type === 'audio';
        const contentUrl = document.bundle
          ? document.actionUrls.openBundle
          : (document.actionUrls.open || (isMedia ? document.documentUrl : null));

        return (
          `<form method="POST" action="${h(editableUrl)}"` +
          ` class="edit-inline" data-controller="edit-inline bubble"` +
          ` data-bubble-event-block-value="click mousedown mouseup">` +
          (`<span class="edit-inline__editable">` +
            `<span class="edit-inline__editable-container">` +
            `<button type="button" class="btn btn-link truncate mt-0 enable-tooltip"` +
            ` title="${h(data)}"` +
            ` aria-label="${h(data)}"` +
            ` data-controller="panel tooltip"` +
            ` data-tooltip-placement-value="top"` +
            ` data-tooltip-boundary-value="viewport"` +
            ` data-tooltip-selector-value=".enable-tooltip"` +
            ` data-panel-title-value="${h(data)}"` +
            (
              // Route media files to data-panel-media-url-value instead of data-panel-image-url-value.
              // Without this, video files (which have image:true) would be sent to openImagePanel,
              // which cannot render media and shows an error.
              contentUrl != null
                ? (isMedia
                  ? ` data-panel-media-url-value="${h(contentUrl)}"`
                  : document.image
                    ? ` data-panel-image-url-value="${h(contentUrl)}"`
                    : ` data-panel-document-url-value="${h(contentUrl)}"`)
                : ``
            ) +
            ` data-edit-inline-target="editable"` +
            ` data-action="panel#open"` +
            `>` +
            `<span class="edit-inline__btn-text">${h(data)}</span>` +
            `</button>` +
            `<button type="button" class="btn btn-sm documents-tbl-action-btn enable-tooltip"` +
            ` data-action="edit-inline#edit"
              aria-owns="${document.documentId}-edit-inline-input-container"
              aria-label="Edit name"
              aria-haspopup="true"
              title="Edit name"
              data-controller="tooltip"
              data-tooltip-placement-value="top"
              data-tooltip-boundary-value="viewport"
              data-tooltip-selector-value=".enable-tooltip"
            >` +
            `<i class="fa-solid fa-pen fa-sm" aria-hidden="true"></i>` +
            `<span class="sr-only">Edit name</span>` +
            `</button>` +
            `</span>` +
            `</span>`) +
          (`<span class="edit-inline__input" role="dialog" id="${document.documentId}-edit-inline-input-container">` +
            ` <label for="${document.documentId}-edit-inline-input" class="sr-only">Edit document name</label>` +
            `<input type="hidden" name="ref" value="${h(documentId)}">` +
            `<input id="${document.documentId}-edit-inline-input" name="update_value" data-edit-inline-target="input" class="input-text"` +
            ` data-action="keydown.enter->edit-inline#complete keydown.esc->edit-inline#cancel blur->edit-inline#cancel">` +
            `<span class="input-group-append">` +
            `<button type="button" class="btn btn-link btn-sm" aria-label="Save"` +
            ` data-action="edit-inline#complete">` +
            `<i class="fa-solid fa-check" aria-hidden="true"></i>` +
            `<span class="fa-sr-only">Save</span>` +
            `</button>` +
            `<button type="button" class="btn btn-link btn-sm" aria-label="Cancel"` +
            ` data-action="edit-inline#cancel">` +
            `<i class="fa-solid fa-xmark" aria-hidden="true"></i>` +
            `<span class="fa-sr-only">Cancel</span>` +
            `</button>` +
            `</span>` +
            `</span>`) +
          `</form>`
        );
      },
    },
	{
	  data: null,
	  name: "attachmentCount",
	  title: '<i class="fa fa-paperclip" aria-hidden="true"></i><span class="sr-only">Attachments</span>',
	  className: "th-attachment-count",
	  orderable: true,
	  visible: false,
	  responsivePriority: 9,
	  render: (data, type, row) => {
	    const isEmail = row.email || row.emailBody;
	    if (!isEmail) return type === "sort" ? 0 : "";

	    const count = controller.attachmentsByTxn?.[row.transactionId]?.length || 0;

	    if (type === "sort" || type === "type") return count;
	    if (type !== "display") return count;

	    if (count === 0) return "";

	    return `<span class="attachment-count-badge"
	      aria-label="Attachments (${count})"
	      title="Attachments (${count})">
	        <i class="fa fa-paperclip" aria-hidden="true"></i>
	        ${count}
	    </span>`;
	  },
	},		
    {
      name: "iconUrl",
      data: "iconUrl",
      title: "Thumbnail",
      visible: false,
      orderable: false,
      responsivePriority: 9,
      render: (value, options, rowData) => {
        if (!rowData.hasIconRepresentation) {
          return "";
        }

        const docId = rowData["documentId"];
        return (
          `<a class="img-thumbnail" ` +
          `title="Click to open image" ` +
          `data-controller="open-panel" ` +
          `data-action="click->open-panel#openImagePanel" ` +
          `data-open-panel-document-name-value="${value}" ` +
          `data-open-panel-image-url-value="${rowData.documentUrl}">` +
          `<img src="${rowData.iconUrl}" ` +
          `loading="lazy" style="max-width:50px;max-height:50px;cursor:pointer" ` +
          `alt="Image uploaded by user - ${rowData.documentName}" ` +
          `title="Image uploaded by user - ${rowData.documentName}" ` +
          `draggable="false"/>` +
          `</a>`
        );
      },
    },
    {
      name: "tags",
      data: "tags",
      title: "Tags",
      responsivePriority: 15,
      //  visible: controller.config.hideTagColumn,
      render: (value, options, rowData) => {
        return `<div style="display: inline">${value || ""}</div>`;
      },
    },
    {
      name: "uploadTime",
      data: "uploadTime",
      title: "Date attached",
      responsivePriority: 16,
      render: (value, options, rowData) => {
        return (
          '<div style="display: inline">' +
          (value
            ? moment
                .utc(value)
                .local()
                .format(
                  controller.config.dateFormat.toUpperCase() + " HH:mm:ss",
                )
            : "") +
          "</div>"
        );
      },
    },
    {
      name: "deletedAt",
      data: "deletedAt",
      title: "Date deleted",
      visible: false,
      responsivePriority: 20,
      render: (value, options, rowData) => {
        return (
          '<div style="display: inline">' +
          (value
            ? moment
                .utc(value)
                .local()
                .format(
                  controller.config.dateFormat.toUpperCase() + " HH:mm:ss",
                )
            : "") +
          "</div>"
        );
      },
    },
    {
      name: "purgeOn",
      data: "purgeOn",
      title: "Purge date",
      visible: false,
      responsivePriority: 20,
      render: (value, options, rowData) => {
        return (
          '<div style="display: inline">' +
          (value
            ? moment
                .utc(value)
                .format(controller.config.dateFormat.toUpperCase())
            : "") +
          "</div>"
        );
      },
    },
    {
      name: "emailFrom",
      data: "emailFrom",
      title: "Email from",
      visible: false,
      responsivePriority: 20,
    },
    {
      name: "emailTo",
      data: "emailTo",
      title: "Email to",
      visible: false,
      responsivePriority: 20,
    },
    {
      name: "uploadedBy",
      data: "uploadedBy",
      title: "Attached by",
      responsivePriority: 17,
      render: (value, options, rowData) => {
        return `<p class="mb-0 truncate enable-tooltip"
              data-controller="tooltip"
              title="${rowData.uploadedBy}"
              data-tooltip-placement-value="top"
              data-tooltip-boundary-value="viewport"
              data-tooltip-selector-value-".enable-tooltip">
            <span>${rowData.uploadedBy}</span>
          </p>`;
      },
    },
    {
      name: "timelineDate",
      data: "timelineDate",
      title: "Document date",
      responsivePriority: 18,
      render: (value, type, row) => {
        return (
          '<div style="display: inline">' +
          (value
            ? moment
                .utc(value)
                .local()
                .format(
                  controller.config.dateFormat.toUpperCase() + " HH:mm:ss",
                )
            : "") +
          "</div>"
        );
      },
    },
    {
      name: "inSummary",
      data: "inSummary",
      title: "In summary",
      responsivePriority: 19,
      visible: false,
      render: (data, type, row) => {
        if (type === "filter") {
          return data ? "summary:yes" : "summary:no";
        }
        return checkboxToggleHtml(
          data,
          `summary_${row.documentId}`,
          "summary",
          `${row.summaryToggleActionDescription}`,
          `${row.summaryToggleUrl}`,
        );
      },
    },
    {
      name: "public",
      data: "public",
      title: "Public",
      responsivePriority: 9,
      visible: false,
      render: (data, type, row) => {
        if (!controller.config.allowPublishedDocuments) {
          return "";
        }
        if (type === "filter") {
          return data ? "public:yes" : "public:no";
        }
        return checkboxToggleHtml(
          data,
          `public_${row.documentId}`,
          "public",
          `${row.selfServiceToggleHtmlLabel}`,
          `${row.selfServiceToggleUrl}`,
        );
      },
    },
    {
      name: "redactedVersionId",
      data: "redactedVersionId",
      title: "Redacted",
      responsivePriority: 20,
      visible: false,
      render: (data, type, row) => {
        if (type === "filter") {
          return data ? "redacted:yes" : "redacted:no";
        }
        return booleanCellHtml(data, "Redacted", "Not redacted");
      },
    },
    {
      name: "keywords",
      data: "keywords",
      type: "document-keywords",
      title: "Keywords",
      responsivePriority: 21,
      visible: false,
    },
    {
      name: "notes",
      data: "notes",
      type: "document-notes",
      title: "Has notes",
      responsivePriority: 17,
      visible: false,
      render: (data, type, row) => {
        if (type === "filter") {
          return (data ? "note:yes " : "note:no ") + data;
        }
        return booleanCellHtml(data, "Has notes", "No notes");
      },
    },
    {
      name: "contextMenu",
      className: "th-actions",
      responsivePriority: 9,
      sortable: false,
      render: (data, options, rowData) => {
        return `
          <button class="btn btn-sm documents-tbl-action-btn enable-tooltip" 
            type="button" data-action="document-list#contextMenuFromClick"
            title="Menu"
            data-controller="tooltip"
            data-tooltip-placement-value="top"
            data-tooltip-boundary-value="viewport"
            data-tooltip-selector-value=".enable-tooltip"
            data-document-list-id-param="${documentIdToParam(
              rowData["documentId"],
            )}">
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            <span class="sr-only">Menu</span>
          </button>`;
      },
    },
  ].filter(Boolean);
}

function booleanCellHtml(value, trueText, falseText) {
  return value ? trueCellHtml(trueText) : falseCellHtml(falseText);
}

function trueCellHtml(text) {
  return (
    '<span class="has-notes-indicator-true"><i class="fa fa-check-circle-o" aria-hidden="true"></i></span>' +
    screenReaderHtml(text)
  );
}

function falseCellHtml(text) {
  return (
    '<span class="has-notes-indicator-false"><i class="fa fa-times-circle-o" aria-hidden="true"></i></span>' +
    screenReaderHtml(text)
  );
}

function screenReaderHtml(text) {
  return `<span class="sr-only">${h(text)}</span>`;
}

function checkboxToggleHtml(text, name, type, label, toggleUrl) {
  const checkedAttribute = text ? "checked" : "";
  return `
    <div data-controller="toggle" data-toggle-type-value="${type}" data-toggle-document-id-value="${name}" data-toggle-action-url-value="${toggleUrl}"  data-toggle-label-value="${label}" data-toggle-checked-attribute-value="${checkedAttribute}"></div>
  `;
}
